export default __webpack_public_path__ + "static/media/nomouth.7842d100.svg";